module.exports = {"id":"205257","name":"Naïm Sliti","rating":"74","photo":"./data/images/photos/1/205257.png","club":{"name":"Dijon FCO","logo":"./data/images/clubs/DijonFCO.png"},"positions":["MG","AG","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NaimSliti0.json
// module id = 3128
// module chunks = 0